import { AtlasHeading, AtlasPageHeader, AtlasSpacer } from "atlas-ds"
import { useSearchParams } from "next/navigation"
import { useRouter } from "next/router"
import { useEntreprise } from "pages/_app"
import { useEffect, useRef } from "react"
import { BRANCHE_CAP, CAP_COMPETENCE_URL } from "services/global"
import { Branche, Modalite, Type } from "services/model"
import Template from "template"
import { Modules } from "./modules"

export interface HomePageProps {
    branches?: Branche[]
    modalites?: Modalite[]
    types?: Type[]
    serverError?: string
}

export function HomePage(props: HomePageProps) {
    const entreprise = useEntreprise()
    const router = useRouter()
    const searchParams = useSearchParams()
    const searchInputRef = useRef<HTMLInputElement>(null)

    useEffect(() => {
        if (entreprise?.branche?.valueName && !searchParams?.get("entreprise")) {

            // Redirection vers l'URL cap compétence si l'entreprise correspond
            if (entreprise?.branche?.valueName === BRANCHE_CAP && router.pathname === "/") {
                router.replace(CAP_COMPETENCE_URL)
            }

            // Redirection vers l'URL racine si l'entreprise ne correspond pas à cap compétence
            else if (entreprise?.branche?.valueName !== BRANCHE_CAP && router.pathname === CAP_COMPETENCE_URL) {
                router.replace('/')
            }
        }
    }, [router.pathname, entreprise?.branche?.valueName])

    return <Template
        showIntro={true}
        pageHeader={<AtlasPageHeader>
            <AtlasHeading tag="h2" size="l">
                Trouvez le module qui vous correspond et boostez vos compétences&nbsp;!&nbsp;🚀
            </AtlasHeading>
        </AtlasPageHeader>}
    >
        <AtlasSpacer size="s" />
        <Modules
            searchInputRef={searchInputRef}
            branches={props.branches}
            modalites={props.modalites ?? []}
            types={props.types ?? []}
        />
    </Template>
}
